import {Account} from '../accounts/account';
import {MediaAccess} from '../accounts/media-access';
import {Address} from '../accounts/address';

export enum CustomerStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
  IN_CREATION = 'IN_CREATION'
}

export class CustomerDetail {
  id: number;
  customerNumber: string;
  userId: number;
  status: CustomerStatus;
  accounts: Account[];
  account: Account;
  mediaAccess: MediaAccess;
  address: Address[];

  constructor(object: any = null) {
    if (object != null) {
      Object.assign(this, object);
      this.status = typeof object.status === 'number' ?? CustomerStatus[object.status as string];
      if (object.accounts != null) {
        this.accounts = object.accounts.map((item) => new Account(item));
      } else {
        this.accounts = [];
      }
    }
  }
}
